export default "__VITE_ASSET__CDDf4X7x__"